import { ReactNode } from 'react';

interface IPublicLayoutProps {
  children: ReactNode;
}

export default function PublicLayout(props: Readonly<IPublicLayoutProps>) {
  return (
    <div className="public-layout">
      <main className="public-main">{props.children}</main>
    </div>
  );
}
